import { UseQueryOptions } from '@tanstack/react-query';

import { VoiceCallerProfile } from 'domains/content/types';
import { CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';

import useQuery from '../useQuery';

const useSenderProfileVoice = (
    senderProfileVoiceId: number | null,
    reactQueryOptions?: UseQueryOptions<VoiceCallerProfile, Error>
) =>
    useQuery<VoiceCallerProfile>(
        ['sender-profile-voice', senderProfileVoiceId?.toString()],
        new PathWithID(CuredApiPaths.SENDER_PROFILES_VOICE, senderProfileVoiceId),
        reactQueryOptions
    );

export default useSenderProfileVoice;
